import { Component, EventEmitter, ViewChild, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, Event, NavigationStart } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CIPXDrawerContentInterface, DRAWER_DATA, DRAWER_REF, DrawerRef } from '@sbd-doug-frontend/shared';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { BondsListItem } from '@sbd-account-portal/app/modules/bonds/bonds-list/bonds-list.type';
import { QuoteRequestsListItem } from '@sbd-account-portal/app/modules/quote/requests-list/quote-request.type';
import {
  BondCancellationComponent
} from '@sbd-account-portal/app/modules/bond-cancellation/bond-cancellation.component';
import { CIPXActionBarComponent } from '@sbd-doug-frontend/shared/lib/ui/action-bar/action-bar.component';
import { CIPXPrimaryButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons/primary-button/primary-button.component';
import { CIPXCancelButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons/cancel-button/cancel-button.component';

export interface BondCancellationDrawerData {
  title?: string;
  qr: OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem;
}

@Component({
  selector: 'sbd-account-portal-frontend-bond-cancellation-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    BondCancellationComponent,
    CIPXActionBarComponent,
    CIPXPrimaryButtonComponent,
    CIPXCancelButtonComponent,
  ],
  templateUrl: './bond-cancellation-wrapper.component.html',
  styleUrl: './bond-cancellation-wrapper.component.scss',
})
export class BondCancellationWrapperComponent implements CIPXDrawerContentInterface<BondCancellationDrawerData>, OnInit, OnDestroy {
  @Output() closeRequested: EventEmitter<void>;
  @ViewChild('form') form!: BondCancellationComponent;

  data = inject(DRAWER_DATA, { optional: true }) as BondCancellationDrawerData | null;
  drawerRef = inject(DRAWER_REF, { optional: true }) as DrawerRef<BondCancellationWrapperComponent> | null;
  private _router = inject(Router);
  private _unsubscribeAll = new Subject<void>();

  concernedQuoteRequest: OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem = this.data?.qr;
  canSubmit = false;

  ngOnInit(): void {
    this.drawerRef?.setTitle(this.data?.title ?? 'Request Bond Cancellation');
    this.drawerRef?.setShowBackButton(true);

    this._router.events
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
          this.closeDrawer();
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    this.drawerRef?.close();
  }

  onBackClick(): void {
    this.closeDrawer();
  }

  closeDrawer(): void {
    this.drawerRef?.close();
  }

  onSubmit(): void {
    this.form?.submit();
  }
}
